import { Typography, styled } from '@mui/material'
import dayjs from 'dayjs'
import React from 'react'
import 'dayjs/locale/pt-br'

dayjs.locale('pt-br')

const StyledInfo = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  '& svg': {
    fill: `${theme.palette.primarySoft.main} !important`
  },
  '& span': {
    color: theme.palette.primarySoft.main
  }
}))

const StyledValue = styled(Typography)(({ theme }) => ({
  color: theme.palette.primarySoft.main,
  fill: `${theme.palette.primarySoft.main} !important`,
  fontWeight: 'bold',
  display: 'flex',
  alignItems: 'center',
  '& span': {
    color: theme.palette.primarySoft.main
  }
}))

const StyledType = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.main,
  fontWeight: 'bold',
  height: '100%',
  display: 'flex',
  alignItems: 'center'
}))

/**
 * IHealthCardProps interface that defines the props for the HealthCard component.
 */
export interface IHealthCardProps {
  /** Optional icon to display alongside the values */
  icon?: JSX.Element
  /** Array of values to display, each with an optional type */
  values: Array<{
    type?: string
    value: number | string | null
  }>
  /** Optional alignment for the display values */
  align?: 'center' | 'left' | 'right'
}

/**
 * DisplayValue component
 * This component renders a display value with an optional icon and type.
 *
 * @param props - The properties for the display value component.
 * @returns The rendered display value component.
 */
export const DisplayValue: React.FC<IHealthCardProps> = props => {
  const { icon, values, align } = props
  return (
    <StyledInfo style={{ justifyContent: align ?? 'left' }}>
      {icon ?? <StyledValue variant='h5'>{icon}</StyledValue>}
      {values.map((value, index) => (
        <React.Fragment key={'display-value-' + index}>
          <StyledValue variant='h5'>{value.value ?? 'N/A'}</StyledValue>
          <StyledType variant='inherit'>
            {value.value !== null && value.type ? value.type : ''}
          </StyledType>
        </React.Fragment>
      ))}
    </StyledInfo>
  )
}

export default DisplayValue
